import React from "react";
import { HiChevronLeft } from "react-icons/hi";
import { MdOutlineFolder } from "react-icons/md";
import MobileOnlyButton from "src/components/MobileOnlyButton";
import { usePlan } from "src/modules/protocols/context";
import ProtocolSetup from "src/modules/protocols/Plan/View/protocol-setup";
import SaveButton from "../SaveButton";
import WorkoutWrapper from "../WorkoutWrapper";

interface Props {
  callbacks: {
    onChangeTitle: (title: string) => void;
    onChangeObs: (obs: string) => void;
    onDelete: (id: string) => void;
    onDuplicate: (id: string) => void;
    onSaveTemplate: (id: string) => void;
    onExport: (id: string) => void;
  };
}

const ProtocolView: React.FC<Props> = (props) => {
  const {
    plan: { selected: plan, unselect },
  } = usePlan();

  if (!plan)
    return (
      <div className="my-auto flex flex-1 flex-col items-center gap-2 text-zinc-800 dark:text-white">
        <MdOutlineFolder size={48} />
        <p>SELECIONE UM PROTOCOLO</p>
      </div>
    );

  return (
    <div className="flex flex-1 flex-col justify-between overflow-x-hidden">
      <WorkoutWrapper protocol={plan.id}>
        <div className="flex h-10 items-center justify-between px-2">
          <MobileOnlyButton icon={HiChevronLeft} size={40} onClick={unselect} />
          <SaveButton />
        </div>
        <ProtocolSetup {...props.callbacks} />
      </WorkoutWrapper>
    </div>
  );
};

export default ProtocolView;
